import {
  addEventListener,
  removeEventListener
} from './event'

function parseData(data) {
  if (typeof data !== 'string') {
    return data
  }
  if (data) {
    try {
      return JSON.parse(data)
    } catch (e) {}
  }
  return {}
}

let eventMap = {}
let messageListener = null

export default class MessageBus {
  constructor({
    namespace,
    domain = window.location.origin,
    target = window
  }) {
    this.namespace = namespace
    this.domain = domain
    this.target = target
    if (target === window) {
      console.warn('MessageBus: current target equals window, is it right?')
    }
    instanceList.push(this)
  }
  static init() {
    addEventListener(window, 'message', messageListener = e => {
      if (e.source === e.target) {
        return
      }
      let messageData = Object.assign({
        event: '',
        data: ''
      }, parseData(e.data))
      debugger
      if (eventMap[messageData.event]) {
        let messageObj = eventMap[messageData.event]
        let result = messageObj.fn(messageData.data, e)
        messageObj.instance.send(messageData.event, result)
      }
    })
    return MessageBus
  }
  static destroy() {
    if (messageListener) {
      removeEventListener(window, 'message', messageListener)
      messageListener = null
    }
    eventMap = {}
  }
  static instance(opts) {
    return new MessageBus(opts)
  }
  getMessageName(name) {
    return [this.namespace, name].join('-')
  }
  on(name, fn) {
    eventMap[this.getMessageName(name)] = {
      instance: this,
      fn
    }
    return this
  }
  remove(name) {
    delete eventMap[this.getMessageName(name)]
    return this
  }
  send(realName, data = '') {
    this.target.postMessage(JSON.stringify({
      event: realName,
      data
    }), this.domain)
  }
  post(name, data) {
    return new Promise(resolve => {
      this.on(name, (data, e) => {
        this.remove(name)
        resolve(data, e)
      })
      this.send(this.getMessageName(name), data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/packages/utils/src/messageBus.js